import { render, staticRenderFns } from "./Trust.vue?vue&type=template&id=5f18bb24"
import script from "./Trust.vue?vue&type=script&lang=js"
export * from "./Trust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports